import React, { useState, useRef, useEffect } from "react";
import "./EntityMultiSelect.css";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";

const ENTITY_COLORS = {
  INC: "#2F80ED",
  APS: "#219653",
  SBS: "#D9982B",
};

const EntityMultiSelect = ({
  options = [],
  selected = [],
  onChange,
  showCombinationOption = false,
  combinationChecked = false,
  onCombinationChange,
}) => {
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const toggleEntity = (ent) => {
    const updated = selected.includes(ent)
      ? selected.filter((x) => x !== ent)
      : [...selected, ent];

    onChange(updated);
  };

  const displayText = selected.length ? selected.join(", ") : "Select Entity";

  return (
    <div className="entity-select-container" ref={panelRef}>
      <div className="entity-select-box" onClick={() => setOpen(!open)}>
        <span className={selected.length ? "entity-value" : "entity-placeholder"}>
          {displayText}
        </span>
        <span className="entity-arrow">
          {open ? <FiChevronUp /> : <FiChevronDown />}
        </span>
      </div>

      {open && (
        <div className="entity-dropdown-panel">
          {/* <div className="entity-dropdown-title">Entity</div> */}

          <div className="entity-dropdown-section">
            <div className="entity-section-label">Select Entities</div>
            <div className="entity-options-column">
              {options.map((ent) => (
                <label key={ent} className="entity-option">
                  <input
                    className="entity-checkbox"
                    type="checkbox"
                    checked={selected.includes(ent)}
                    onChange={() => toggleEntity(ent)}
                  />
                  <span
                    className="entity-color-dot"
                    style={{ backgroundColor: ENTITY_COLORS[ent] || "#9a49cd" }}
                  />
                  <span>{ent}</span>
                </label>
              ))}
            </div>
          </div>

          {showCombinationOption && (
            <div className="entity-dropdown-section entity-filter-section">
              <div className="entity-section-label">Filter Mode</div>
              <div className="entity-filter-toggle" role="group" aria-label="Entity filter mode">
                <button
                  type="button"
                  className={!combinationChecked ? "active" : ""}
                  onClick={() => onCombinationChange?.(false)}
                >
                  Any selected
                </button>
                <button
                  type="button"
                  className={combinationChecked ? "active" : ""}
                  onClick={() => onCombinationChange?.(true)}
                >
                  All must match
                </button>
              </div>
              <div className="entity-filter-note">
                Any selected = products in any chosen entity. All must match =
                products shared by every chosen entity.
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default EntityMultiSelect;
